import React from "react";
import { connect } from "react-redux";
import _, { values } from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import AropiReport2Plus from "./AropiReport";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
  Typography,
  Menu,
  Dropdown,
  Radio,
} from "antd";
import {
  Document9,
  DocumentCount,
  DocumentCount1,
} from "./ReportDocuments/Document_9";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import { TwoPlusService } from "../../_services/towplus.service";
import { twoPlusAction } from "../../_actions/twoplus.actions";
import MyTable from "./ReportDocuments/MyTable";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ClearOutlined,
  DownOutlined,
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
import { downloadGunaListPdf } from "../../_helpers/downloadGunaListPdf";

const { Text } = Typography;

const TableReport2Plus = React.lazy(() =>
  import("./Tables/TableReport2Plus").then((module) => ({
    default: module.TableReport2Plus,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

const styles = {
  pageContainer: {
    padding: "16px 0",
    width: "100%",
  },
  headerCard: {
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  filterSection: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    width: "100%",
  },
  formItem: {
    flex: "1 1 280px",
    minWidth: "280px",
    marginBottom: 0,
  },
  selectInput: {
    width: "100%",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "flex-end",
  },
  actionButton: {
    minWidth: "120px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  downloadSection: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: "16px",
    padding: "16px",
    borderTop: "1px solid #f0f0f0",
  },
  downloadGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: "flex-end",
  },
};

class Plus2ReportPolice extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    district_name: "",
    loading: false,
    downloadLoding: false,
    report_4_startDate: "",
    report_4_endDate: "",
    report4_loader: false,
    report4_List: [],
    report4_List1: [],
    report4_List_Total: 0,
    report4_API_loader: false,
    totalCriminal: 0,
    crimeTitle: [],
    setCriminalViewModel: false,
    PlusViewForm_List: [],
    report_type: null,
    newArophiData: [],
    arophiCount: [],
    arophiListCount: [],
    arophiList: [],
    historyCount: [],
    historyList: [],
    showList: "यादी",
    showModal: false,
    filter: "",
    dates: [],
    download: "arophi_excel",
    showFilterSection: false,
    order_by: "",
    direction: "",
    is_sort: false,
    preventiveAction: [],
    advancedFilterPhoto: "all",
    activeMainTab: "list",
    graphAppliedStartDate: "",
    graphAppliedEndDate: "",
    graphRefreshKey: 0,
    tableSort: { field: "", order: "" },
    selectedLastDistricts: [],
    selectedPreventiveStatuses: [],
    visibleExportIds: null,
  };

  getPreventiveExportStatus = (item) => {
    const records = item?.prevetive_records?.length
      ? item.prevetive_records
      : item?.prevetive_record?.length
        ? item.prevetive_record
        : [];
    if (!records.length) return "-";

    const firstRecord = records[0];
    if (!firstRecord?.date_to) return "-";

    return moment(firstRecord.date_to).isBefore(moment(), "day")
      ? "completed"
      : "ongoing";
  };

  applyListViewToExport = (items) => {
    let result = [...(items || [])];
    const visibleIds = this.state.visibleExportIds;
    if (this.state.showList === "यादी" && Array.isArray(visibleIds)) {
      const idSet = new Set(visibleIds.map((id) => String(id)));
      result = result.filter((item) =>
        idSet.has(String(item.masterId ?? item.id)),
      );
    } else {
      const selected = this.state.selectedLastDistricts || [];
      if (selected.length > 0) {
        result = result.filter((item) =>
          selected.includes(item.last_districtName),
        );
      }

      const selectedStatuses = this.state.selectedPreventiveStatuses || [];
      if (selectedStatuses.length > 0) {
        result = result.filter((item) =>
          selectedStatuses.includes(this.getPreventiveExportStatus(item)),
        );
      }
    }

    const { field, order } = this.state.tableSort || {};
    if (field && order) {
      const direction = order === "descend" ? -1 : 1;
      result.sort((a, b) => {
        if (field === "totalCrimeCount") {
          const aCount = Number(a.totalCrimeCount) || 0;
          const bCount = Number(b.totalCrimeCount) || 0;
          return direction * (aCount - bCount);
        }
        if (field === "last_districtName") {
          const cmp = String(a.last_districtName || "").localeCompare(
            String(b.last_districtName || ""),
            undefined,
            { sensitivity: "base" },
          );
          return direction * cmp;
        }
        return 0;
      });
    }

    return result;
  };

  componentDidMount() {
    const { user } = this.props;

    this.setState({ showList: "यादी" });
    this.getDistrictsid();

    this.getPreventiveInfo();
    if (!this.props.professionals?.pc_crimetitles) {
      this.props.dispatch(professionalAction.getCrimeTitle());
    }
    this.props.dispatch(professionalAction.getCity());
  }
  getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          this.setState({
            preventiveAction: data,
            preventiveActionData: JSON.parse(preventiveList),
          });
        });
    });
  };

  disabledEndDate = (current) => {
    const { report_4_startDate } = this.state;
    if (!report_4_startDate) return false;

    const start = moment(report_4_startDate).startOf("day");
    return current.isBefore(start, "day"); // block anything before start date
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    const { report_4_startDate } = this.state;

    this.setState(
      {
        report_4_endDate: date.toISOString(),
      },
      () => {
        if (report_4_startDate) {
          const start = moment(report_4_startDate);
          const end = moment(date);

          if (end.diff(start, "years", true) > 5) {
            message.warning("Date range cannot be more than 5 year!");
            this.setState({ isMoreThanOneYear: true });
          } else {
            this.setState({ isMoreThanOneYear: false });
          }
        }
      },
    );
  };
  getExportRows = () => {
    const { t } = this.context;
    const { showList } = this.state;
    let list = [];
    const data = this.applyListViewToExport(
      this.state.report_type === "arophi_new_list"
        ? this.state.arophiListCount
        : this.state.report4_List,
    );
    console.log("data", data);
    list =
      this.state.report_type == "history_sheeter"
        ? this.state.report4_List &&
          this.state.report4_List.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("age")]: data.age ? data.age : "-",
            [t("history_sheeter_entry_date")]: data.history_date
              ? moment(data.history_date).format("DD-MM-YYYY")
              : "-",
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : "-",
            [t("total_crimes ")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            [t("photo")]: data.photo ? t("yes") : t("no"),
          }))
        : data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : data.crime_districtName
                ? data.crime_districtName
                : "-",
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "-",
            [t("total_crimes")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            "शेवटचा गुन्ह्याचे पो. स्टे": data.last_districtName
              ? data.last_districtName
              : "-",
            "CR.No/DateTime": `${data.cr_no ? data.cr_no : "-"} - ${
              data.guna_date ? data.guna_date : "-"
            }`,
            [t("photo")]: data.photo ? t("yes") : t("no"),
          }));
    console.log("final list", list);
    let list2 = [];
    list2 =
      this.state.report_type === "new arophi"
        ? this.state.report4_List1 &&
          this.state.report4_List1 &&
          this.state.report4_List1.map((data, index) => {
            const मालाविषयक = parseInt(data["मालाविषयक"]) || 0;
            const शरीराविषयक = parseInt(data["शरीराविषयक"]) || 0;
            const अवैध_वाळू_विषयक = parseInt(data["अवैध वाळू विषयक"]) || 0;
            const अवैध_दारु_विषयक = parseInt(data["अवैध दारु विषयक"]) || 0;
            const जुगारविषयक = parseInt(data["जुगारविषयक"]) || 0;
            const भाग_६ = parseInt(data["भाग - ६"]) || 0;
            const इतर = parseInt(data["भाग - ६"]) || 0;

            const total =
              मालाविषयक +
              शरीराविषयक +
              अवैध_वाळू_विषयक +
              अवैध_दारु_विषयक +
              जुगारविषयक +
              भाग_६ +
              इतर;

            return {
              [t("sr.no")]: index + 1,
              [t("crime_police_station")]: data.districtName,
              [t("body_offender")]: शरीराविषयक,
              [t("property_offender")]: मालाविषयक,
              [t("illegal_sand_transportation")]: अवैध_वाळू_विषयक,
              [t("illegal_liquor_related")]: अवैध_दारु_विषयक,
              [t("gambling_related")]: जुगारविषयक,
              [t("section_6")]: भाग_६,
              [t("other_crimes")]: इतर,
              [t("total")]: total,
            };
          })
        : this.state.report_type === "history_sheeter"
          ? this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("history_sheeter_statistics")]: data.Count_district,
              };
            })
          : this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("2_plus_statistics")]: data.crimeCount,
              };
            });
    console.log("showList", showList);
    const arrData1 =
      showList === "सांख्यिकी" || this.state.report_type == "new arophi"
        ? list2
        : list;

    return arrData1;
  };
  download_pdf = async () => {
    const { t } = this.context;
    const { filter } = this.state;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    let ReportTitle = "";
    const title =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type == "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("two_plus_accused");

    if (this.state.report_type === "new arophi") {
      ReportTitle = t("accused_new_cases_statistics");
    } else if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : `${t("data_entered_by_police_station1")} - ${t("statistics1")}`
      }`;
    } else if (this.state.report_type === "arophi_new_list") {
      ReportTitle = `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "more_than_two_plus_list") {
      ReportTitle = `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "history_sheeter") {
      ReportTitle = `${t("history")} - ${
        this.state.showList === "सांख्यिकी" ? t("statistics1") : t("list")
      }`;
    } else {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    }
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: ReportTitle,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "guna_excel") {
      this.download_csv();
    }
    if (download == "guna_pdf") {
      this.download_guna_pdf();
    }
    if (download == "arophi_excel" || download === "excel") {
      this.download_csv1();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  getGunaReportTitle = () => {
    const { t } = this.context;
    const { filter } = this.state;

    if (this.state.report_type === "new arophi") {
      return t("accused_new_cases_statistics");
    }
    if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      return `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits")
          : `${t("data_entered_by_police_station")} - ${t("statistics1")}`
      }`;
    }
    if (this.state.report_type === "arophi_new_list") {
      return `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    }
    if (this.state.report_type === "more_than_two_plus_list") {
      return `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_crime")
          : t("data_entered_by_police_crime")
      }`;
    }
    return `${t("two_plus_accused")} - ${
      filter === "by_distinct"
        ? t("info_within_police_station_limits")
        : t("data_entered_by_police_station")
    }`;
  };

  getGunaFileName = () => {
    const { t } = this.context;
    const report_name =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type === "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("two_plus_accused");
    return `${report_name}_${moment().format("DDMMMYYYY")}`;
  };

  getGunaExportTableData = () => {
    const { t } = this.context;
    const criminalList = this.applyListViewToExport(
      this.state.report4_List || [],
    );
    const accusedFixedCols = 6;

    const currentStatusLabel = `${t("current_status")} (${moment().format(
      "DD-MM-YYYY",
    )})`;

    const headers = [
      t("sr.no"),
      t("accused_police_station"),
      t("name"),
      t("address"),
      t("total_crimes"),
      t("photo"),
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      currentStatusLabel,
      t("date_from"),
      t("date_to"),
    ];

    const rows = [];
    const accusedGroups = [];

    const buildDetailRow = (gunha, action) => {
      const detailRow = [];

      if (gunha) {
        detailRow.push(
          gunha.crime_title || "-",
          gunha.districtName || "-",
          gunha.registernumber || "-",
          gunha.registernumberYear
            ? moment(gunha.registernumberYear).format("YYYY")
            : "-",
          gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-",
        );

        let lawData = "-";
        if (gunha.kk_info?.length) {
          const grouped = {};
          gunha.kk_info.forEach((r) => {
            const name = r.rulesName || "-";
            const kalma = r.kalam || "-";
            grouped[name] = grouped[name]
              ? Array.from(new Set([...grouped[name], kalma]))
              : [kalma];
          });
          lawData = Object.entries(grouped)
            .map(([n, k]) => `${n}: ${k.join(", ")}`)
            .join("\n");
        }
        detailRow.push(lawData);
      } else {
        detailRow.push("", "", "", "", "", "");
      }

      if (action) {
        detailRow.push(
          action.preventive_action_name || "-",
          action.date_to && moment(action.date_to).isBefore(moment(), "day")
            ? t("completed")
            : t("ongoing"),
          action.date_from
            ? moment(action.date_from).format("DD-MM-YYYY")
            : "-",
          action.date_to ? moment(action.date_to).format("DD-MM-YYYY") : "-",
        );
      } else {
        detailRow.push("", "", "", "");
      }

      return detailRow;
    };

    criminalList.forEach((accused, idx) => {
      const gunhas = (accused.gunha_records || []).sort(
        (a, b) => new Date(b.dateTime) - new Date(a.dateTime),
      );
      const preventive = accused.prevetive_records || [];
      const maxRows = Math.max(gunhas.length, preventive.length, 1);
      const detailRows = [];

      const accusedCells = [
        idx + 1,
        accused.districtName || accused.crime_districtName || "-",
        accused.name || "-",
        accused.address || "-",
        accused.totalCrimeCount || "-",
        accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No",
      ];

      for (let i = 0; i < maxRows; i++) {
        const gunha = gunhas[i];
        const action = preventive[i];
        const detailRow = buildDetailRow(gunha, action);
        detailRows.push(detailRow);

        const row = [...accusedCells];
        if (i > 0) {
          for (let k = 0; k < accusedFixedCols; k++) row[k] = "";
        }
        rows.push([...row, ...detailRow]);
      }

      accusedGroups.push({
        accused: accusedCells,
        detailRows,
      });
    });

    return {
      headers,
      rows,
      accusedGroups,
      reportTitle: this.getGunaReportTitle(),
      file_name: this.getGunaFileName(),
    };
  };

  download_guna_pdf = async () => {
    const { t } = this.context;
    const { headers, accusedGroups, reportTitle, file_name } =
      this.getGunaExportTableData();

    if (!accusedGroups.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    const dateRangeText = `${t("from")} ${moment(
      this.state.report_4_startDate,
    ).format("DD-MM-YYYY")} - ${t("to")} ${moment(
      this.state.report_4_endDate,
    ).format("DD-MM-YYYY")}`;

    this.setState({ downloadLoding: true });
    try {
      await downloadGunaListPdf({
        headerText,
        reportTitle,
        dateRangeText,
        headers,
        accusedGroups,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  getShowList = (value) => {
    this.setState({ showList: value, selectedPreventiveStatuses: [] });
  };

  toggleGraphView = () => {
    const isGraphView = this.state.activeMainTab === "graph";
    if (isGraphView) {
      this.setState((prev) => ({
        activeMainTab: "list",
        showList: prev.showList === "graph" ? "यादी" : prev.showList,
      }));
      return;
    }

    this.setState({ activeMainTab: "graph" }, () => {
      if (this.canLoadGraph()) {
        this.handleGraphFind();
      }
    });
  };

  canLoadGraph = (state = this.state) => {
    const {
      report_type,
      filter,
      report_4_startDate,
      report_4_endDate,
      isMoreThanOneYear,
    } = state;

    if (!report_type || !filter) return false;
    if (!report_4_startDate || !report_4_endDate || isMoreThanOneYear) {
      return false;
    }
    return true;
  };

  handleGraphFind = () => {
    if (!this.canLoadGraph()) return;
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.setState((prev) => ({
      graphAppliedStartDate: startDate,
      graphAppliedEndDate: endDate,
      graphRefreshKey: (prev.graphRefreshKey || 0) + 1,
    }));
  };

  isFindDisabled = () => {
    const {
      activeMainTab,
      report_type,
      filter,
      report_4_startDate,
      report_4_endDate,
      isMoreThanOneYear,
    } = this.state;

    if (!report_type || !filter) return true;

    if (activeMainTab === "graph") {
      return !report_4_startDate || !report_4_endDate || isMoreThanOneYear;
    }

    if (
      report_type !== "history_sheeter" &&
      (!report_4_startDate || isMoreThanOneYear)
    ) {
      return true;
    }

    return false;
  };

  handleFind = () => {
    if (this.isFindDisabled()) return;
    if (this.state.activeMainTab === "graph") {
      this.handleGraphFind();
    } else {
      this.getData();
    }
  };

  clearFilter = () => {
    if (this.state.crimeTitle.length > 0) {
      this.setState(
        {
          crimeTitle: [],
          is_sort: false,
          report4_List: [],
          report4_List1: [],
          key: "",
          order_by: "",
          direction: "",
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    } else {
      this.setState(
        {
          crimeTitle: [],
          is_sort: false,
          report4_List: [],
          report4_List1: [],
          key: "",
          order_by: "",
          direction: "",
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    }
  };

  getData = () => {
    if (this.state.report_type === "arophi count") {
      this.get2lusArophiByUserIdCount();
      this.get2plusNewArophiByidList();
    }
    if (this.state.report_type === "arophi_new_list")
      this.get2lusArophiListByIdCount();
    if (this.state.report_type === "history_sheeter") {
      // this.getHistorySheeterByIdCount();
      this.getHistorySheeterByIdList();
    }
    if (this.state.report_type === "more_than_two_plus_list") {
      this.getAccusedListWithTwoOrMoreCount();
    }
  };

  getAccusedListWithTwoOrMoreCount = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      direction,
      order_by,
    } = this.state;
    const { user } = this.props;
    console.log("this.state.filter", this.state.filter);
    if (this.state.filter == "by_id") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      PoliceSideActions.getAccusedListWithTwoOrMoreCount(policeobj).then(
        (res) => {
          let list = res.results;
          let columns1 =
            list &&
            list &&
            list.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });
          this.setState({
            arophiListCount: tempObj,
            report4_API_loader: false,
            report4_List: tempObj,
            report4_List1: tempObj,
            total: tempObj.length,
            report4_List_backup: list,
          });
          if ((order_by && direction) || this.state.crimeTitle.length > 0) {
            this.setState({
              is_sort: true,
            });
          }
        },
      );
    }
    if (this.state.filter === "by_distinct") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      PoliceSideActions.getAccusedListWithTwoOrMoreByIdCount(policeobj).then(
        (res) => {
          let list = res.results;
          let columns1 =
            list &&
            list &&
            list.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });
          this.setState({
            arophiListCount: tempObj,
            report4_API_loader: false,
            report4_List: tempObj,
            report4_List1: tempObj,
            total: tempObj.length,
            report4_List_backup: list,
          });
          if ((order_by && direction) || this.state.crimeTitle.length > 0) {
            this.setState({
              is_sort: true,
            });
          }
        },
      );
    }
  };

  get2plusNewArophiByidList = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      direction,
      order_by,
    } = this.state;
    const { user } = this.props;
    console.log("this.state.filter", this.state.filter);
    if (this.state.filter == "by_id") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      twoPlusAction.get2plusNewArophiByidList(policeobj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            this.setState({
              arophiList: tempObj,
              report4_API_loader: false,
              report4_List: list,
              report4_List1: list,
              total: list.length,
              report4_List_backup: list,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    }
    if (this.state.filter === "by_distinct") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      twoPlusAction
        .get2plusNewArophiListPoliceStation(policeobj)
        .then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              this.setState({
                arophiList: tempObj,
                report4_API_loader: false,
                report4_List: list,
                report4_List1: list,
                total: list.length,
                report4_List_backup: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
    }
  };

  get2lusArophiListByIdCount = () => {
    const {
      report_4_startDate,
      report_4_endDate,
      crimeTitle,
      order_by,
      direction,
    } = this.state;
    const { user } = this.props;

    if (this.state.filter === "by_id") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      twoPlusAction.get2lusArophiListByIdCount(policeobj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              arophiListCount: tempObj,
              report4_API_loader: false,
              report4_List: tempObj,
              report4_List1: tempObj,
              total: tempObj.length,
              report4_List_backup: list,
            });
            if ((order_by && direction) || this.state.crimeTitle.length > 0) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    }
    if (this.state.filter === "by_distinct") {
      this.setState({
        report4_API_loader: true,
      });
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
        heading: crimeTitle,
        direction: direction ? direction : "",
        order_by: order_by ? order_by : "",
      };
      twoPlusAction
        .get2lusArophiListPoliceStationCount(policeobj)
        .then((res) => {
          res &&
            res.text().then(async (text) => {
              const criminal = text && JSON.parse(text);
              let list = criminal.results;

              let tempFilterData = _.filter(
                list && _.flatten(list),
                function (o) {
                  return Object.keys(o).length !== 0;
                },
              );
              tempFilterData = _.filter(
                tempFilterData && _.flatten(tempFilterData),
                function (item) {
                  return item.gunhaCount > 1;
                },
              );

              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                arophiListCount: tempObj,
                report4_API_loader: false,
                report4_List: tempObj,
                report4_List1: tempObj,
                total: tempObj.length,
                report4_List_backup: list,
              });
              if ((order_by && direction) || this.state.crimeTitle.length > 0) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
    }
  };

  getHistorySheeterByIdCount = () => {
    const { user } = this.props;
    const { report_4_startDate, report_4_endDate } = this.state;

    if (this.state.filter === "by_id") {
      this.setState({
        report4_API_loader: true,
      });
      const id = user && user.id;
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.id,
      };
      twoPlusAction.getHistorySheeterByIdCount(policeobj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyCount: tempObj,
              report4_API_loader: false,
              report4_List1: tempObj,
              report4_List: tempObj,
              total: tempObj.length,
            });
          });
      });
    }
    if (this.state.filter === "by_distinct") {
      this.setState({
        report4_API_loader: true,
      });
      const id = user && user.districtId;
      let policeobj = {
        startDate: report_4_startDate,
        endDate: report_4_endDate,
        id: user && user.districtId,
      };
      twoPlusAction.getHistorySheeterCountPS(policeobj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const criminal = text && JSON.parse(text);
            let list = criminal.results;

            let tempFilterData = _.filter(
              list && _.flatten(list),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );

            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });

            this.setState({
              historyCount: tempObj,
              report4_API_loader: false,
              report4_List1: tempObj,
              report4_List: tempObj,
              total: tempObj.length,
            });
          });
      });
    }
  };

  getHistorySheeterByIdList = () => {
    const { user } = this.props;
    const { report_4_startDate, report_4_endDate, order_by, direction } =
      this.state;

    // if (this.state.filter === "by_id") {
    let policeobj = {
      startDate: report_4_startDate,
      endDate: report_4_endDate,
      id: user && user.id,
      direction: direction ? direction : "",
      order_by: order_by ? order_by : "",
    };
    this.setState({
      report4_API_loader: true,
    });
    twoPlusAction.getHistorySheeterByIdList(policeobj).then((res) => {
      res &&
        res.text().then(async (text) => {
          const criminal = text && JSON.parse(text);
          let list = criminal.results;

          let tempFilterData = _.filter(list && _.flatten(list), function (o) {
            return Object.keys(o).length !== 0;
          });
          tempFilterData = _.filter(
            tempFilterData && _.flatten(tempFilterData),
            function (item) {
              return item.gunhaCount > 1;
            },
          );

          let columns1 =
            list &&
            list &&
            list.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });

          this.setState({
            historyList: tempObj,
            report4_API_loader: false,
            report4_List: tempObj,
            report4_List1: tempObj,
            total: list.length > 0 && list.length,
          });
          if ((order_by && direction) || this.state.crimeTitle.length > 0) {
            this.setState({
              is_sort: true,
            });
          }
        });
    });
    // }
    // if (this.state.filter === "by_distinct") {
    //   this.setState({
    //     report4_API_loader: true,
    //   });
    //   let policeobj = {
    //     startDate: report_4_startDate,
    //     endDate: report_4_endDate,
    //     district: user && user.districtId,
    //     direction: direction ? direction : "",
    //     order_by: order_by ? order_by : "",
    //   };
    //   twoPlusAction.getHistorySheeterListPS(policeobj).then((res) => {
    //     res &&
    //       res.text().then(async (text) => {
    //         const criminal = text && JSON.parse(text);
    //         let list = criminal.results;

    //         let tempFilterData = _.filter(
    //           list && _.flatten(list),
    //           function (o) {
    //             return Object.keys(o).length !== 0;
    //           }
    //         );
    //         tempFilterData = _.filter(
    //           tempFilterData && _.flatten(tempFilterData),
    //           function (item) {
    //             return item.gunhaCount > 1;
    //           }
    //         );

    //         let columns1 =
    //           list &&
    //           list &&
    //           list.map((itemObj, index) => {
    //             return {
    //               ...itemObj,
    //             };
    //           });

    //         let tempObj = columns1.map((res, index) => {
    //           return {
    //             ...res,
    //           };
    //         });

    //         this.setState({
    //           historyList: tempObj,
    //           report4_API_loader: false,
    //           report4_List: tempObj,
    //           report4_List1: tempObj,
    //           total: list.length > 0 && list.length,
    //         });
    //         if ((order_by && direction) || this.state.crimeTitle.length > 0) {
    //           this.setState({
    //             is_sort: true,
    //           });
    //         }
    //       });
    //   });
    // }
  };

  isSameDate(dates) {
    return (
      moment(dates[0]).isSame(dates[1], "day") &&
      moment(dates[0]).isSame(dates[1], "month") &&
      moment(dates[0]).isSame(dates[1], "year")
    );
  }
  getFormat(date) {
    if (isNaN(date)) {
      return moment(new Date(date).getTime(), "x").format("DD/MM/YY");
    } else {
      return moment(new Date().getTime(), "x").format("DD/MM/YY");
    }
  }

  isSameDateCompareWithData(compareDate, filterDate) {
    if (this.getFormat(compareDate) === this.getFormat(filterDate)) {
      return true;
    }
    return false;
  }

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    var objDate = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
      heading: this.state.crimeTitle,
    };
    this.setState({
      report4_loader: true,
    });

    let DocumentComponent;

    if (this.state.report_type === "new arophi") {
      DocumentComponent = DocumentCount;
    } else if (
      (this.state.report_type == "arophi count" ||
        this.state.report_type == "history_sheeter") &&
      this.state.showList == "सांख्यिकी"
    ) {
      DocumentComponent = DocumentCount1;
    } else {
      DocumentComponent = Document9;
    }

    let name = "";
    const startDate = moment(this.state.report_4_startDate).format("DD/MM/YY");
    const endDate = moment(this.state.report_4_endDate).format("DD/MM/YY");
    if (this.state.report_type == "new arophi") {
      name = "आरोपी विरुद्ध नव्याने दाखल गुन्ह्याची आकडेवारी";
    } else if (this.state.report_type == "arophi_new_list") {
      name = "2 प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची यादी";
    } else if (
      this.state.report_type == "arophi count" &&
      this.state.showList == "सांख्यिकी"
    ) {
      name = "2 प्लस आरोपी - सांख्यिकी";
    } else if (
      this.state.report_type == "arophi count" &&
      this.state.showList == "यादी"
    ) {
      name = "2 प्लस आरोपी - यादी";
    } else if (
      this.state.report_type == "history_sheeter" &&
      this.state.showList == "यादी"
    ) {
      name = "हिस्ट्रीशिटर - यादी";
    } else if (
      this.state.report_type == "history_sheeter" &&
      this.state.showList == "सांख्यिकी"
    ) {
      name = "हिस्ट्रीशिटर - सांख्यिकी";
    } else {
      name = "2 प्लस आरोपी";
    }

    const blob = await pdf(
      <DocumentComponent
        rows={
          this.state.report_type === "new arophi"
            ? this.state.newArophiData
            : this.state.report_type == "arophi count" &&
                this.state.showList == "सांख्यिकी"
              ? this.state.arophiCount
              : this.state.report_type == "history_sheeter" &&
                  this.state.showList == "सांख्यिकी"
                ? this.state.report4_List1
                : this.state.report4_List
        }
        filterDate={
          this.state.report_type != "history_sheeter" ? objDate : null
        }
        allTotal={this.state.totalCriminal}
        total={this.state.report4_List_Total}
        cityName={this.getCityName(user && user.cityId)}
        report_name={name}
        user={user?.role}
        report_type={this.state.report_type}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report4_loader: false,
      });

      let fileName = name;

      if (this.state.report_type != "history_sheeter") {
        fileName += ` ${startDate} to ${endDate}`;
      }

      saveAs(blob, fileName);

      // saveAs(blob, name + " " + startDate + "to" + endDate);
    }
  };
  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  generatePDFReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      cityId: user && user.cityId,
      heading: this.state.crimeTitle,
    };
    let policeobj = {
      startDate: this.state.report_4_startDate,
      endDate: this.state.report_4_endDate,
      id: user && user.districtId,
      heading: this.state.crimeTitle,
    };
    this.setState({
      report4_API_loader: true,
    });
    if (user?.role === "2") {
      professionalAction.getPoliceStation2PlusReports(policeobj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            let tempFilterData = _.filter(
              tempData && _.flatten(tempData),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );
            this.setState({
              report4_API_loader: false,
              report4_List: tempFilterData,
            });
          });
      });
    } else {
      professionalAction.get2PlusReports(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            let tempFilterData = _.filter(
              tempData && _.flatten(tempData),
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            tempFilterData = _.filter(
              tempFilterData && _.flatten(tempFilterData),
              function (item) {
                return item.gunhaCount > 1;
              },
            );
            this.setState({
              report4_API_loader: false,
              report4_List: tempFilterData,
            });
          });
      });
    }
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });

      this.setState({
        report_4_startDate: dates[0],
        report_4_endDate: dates[1],
      });
    }
  };

  onViewAccusedForm = (data) => {
    if (data) {
      let obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: data,
        heading: this.state.crimeTitle,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  selectReportType = (value) => {
    this.setState(
      {
        report_type: value,
        showList: "यादी",
        activeMainTab: "list",
        total: "",
        is_sort: false,
        showFilterSection: false,
        order_by: "",
        direction: "",
        crimeTitle: [],
        selectedPreventiveStatuses: [],
      },
      () => {},
    );
    this.setState({
      total: "",
      report4_List: [],
      report4_List1: [],
      arophiCount: [],
      historyCount: [],
      historyList: [],
      newArophiData: [],
      arophiListCount: [],
      arophiList: [],
    });
  };

  selectfilter = (value) => {
    this.setState(
      {
        filter: value,
        order_by: "",
        direction: "",
        showFilterSection: false,
        crimeTitle: [],
      },
      () => {},
    );
  };
  get2lusArophiByUserIdCount = () => {
    const { report_4_startDate, report_4_endDate } = this.state;
    const startDate = moment(report_4_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_4_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;

    TwoPlusService.get2lusArophiByUserIdCount(
      startDate,
      endDate,
      user?.id,
    ).then((res) => {});
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  getDistrictsid = () => {
    console.log("users id", this.props);
    professionalAction
      .getDistrictsid(this.props.user.districtId)
      .then((res) => {
        console.log("res", res);

        const tempData = res.pc_districts;
        console.log("text", tempData[0]?.DistrictName);
        this.setState({
          district_name: tempData[0]?.DistrictName,
        });
      });
  };

  handleTableSortChange = (sortInfo) => {
    this.setState({
      tableSort: {
        field: sortInfo?.field || "",
        order: sortInfo?.order || "",
      },
    });
  };

  handleDistrictFilterChange = (districts) => {
    this.setState({
      selectedLastDistricts: districts || [],
    });
  };

  handlePreventiveFilterChange = (statuses) => {
    this.setState({
      selectedPreventiveStatuses: statuses || [],
    });
  };

  handleVisibleRowsChange = (ids) => {
    const current = this.state.visibleExportIds;
    const same =
      current === ids ||
      (current == null && ids == null) ||
      (Array.isArray(current) &&
        Array.isArray(ids) &&
        current.length === ids.length &&
        current.every((id, index) => String(id) === String(ids[index])));
    if (same) return;
    this.setState({ visibleExportIds: ids });
  };

  download_csv1 = () => {
    const { t, language } = this.context;
    const { showList, filter } = this.state;
    const report_name =
      this.state.report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : this.state.report_type === "arophi count" &&
            this.state.showList === "सांख्यिकी"
          ? t("two_plus_accused")
          : this.state.report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : this.state.report_type === "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : this.state.report_type === "history_sheeter"
                ? t("history")
                : t("two_plus_accused");
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "";

    if (this.state.report_type === "new arophi") {
      ReportTitle = t("accused_new_cases_statistics");
    } else if (
      this.state.report_type === "arophi count" &&
      this.state.showList === "सांख्यिकी"
    ) {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : `${t("data_entered_by_police_station1")} - ${t("statistics1")}`
      }`;
    } else if (this.state.report_type === "arophi_new_list") {
      ReportTitle = `${t("two_plus_accused_list")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "more_than_two_plus_list") {
      ReportTitle = `${t("accused_combined_list_2_plus")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    } else if (this.state.report_type === "history_sheeter") {
      ReportTitle = `${t("history")} - ${
        this.state.showList === "सांख्यिकी" ? t("statistics1") : t("list")
      }`;
    } else {
      ReportTitle = `${t("two_plus_accused")} - ${
        filter === "by_distinct"
          ? t("info_within_police_station_limits1")
          : t("data_entered_by_police_station1")
      }`;
    }

    let list = [];
    const data = this.applyListViewToExport(
      this.state.report_type === "arophi_new_list"
        ? this.state.arophiListCount
        : this.state.report4_List,
    );
    console.log("data", data);
    list =
      this.state.report_type == "history_sheeter"
        ? data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "",
            [t("age")]: data.age ? data.age : "-",
            [t("history_sheeter_entry_date")]: data.history_date
              ? moment(data.history_date).format("DD-MM-YYYY")
              : "-",
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : "-",
            [t("total_crimes ")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            [t("photo")]:
              data.photo && data.photo.length && data.photo[0] != ""
                ? t("yes")
                : t("no"),
          }))
        : data &&
          data.map((data, index) => ({
            [t("sr.no")]: index + 1,
            [t("accused_police_station")]: data.districtName
              ? data.districtName
              : data.crime_districtName
                ? data.crime_districtName
                : "-",
            [t("name")]: data.name ? data.name : "-",
            [t("address")]: data.address ? data.address : "",
            [t("total_crimes")]: data.totalCrimeCount
              ? data.totalCrimeCount
              : "-",
            "शेवटचा गुन्ह्याचे पो. स्टे": data.last_districtName
              ? data.last_districtName
              : "-",
            "CR.No/DateTime": `${data.cr_no ? data.cr_no : "-"} - ${
              data.guna_date ? data.guna_date : "-"
            }`,
            [t("photo")]:
              data.photo && data.photo.length && data.photo[0] != ""
                ? t("yes")
                : t("no"),
            [t("action_type")]:
              data?.prevetive_records?.at(-1)?.preventive_action_name || "-",
            [t("preventive_action")]: (() => {
              if (
                !data.prevetive_records ||
                data.prevetive_records.length === 0
              ) {
                return "-";
              }

              const firstRecord = data.prevetive_records[0];

              if (!firstRecord.date_to) {
                return "-";
              }

              return moment(firstRecord.date_to).isBefore(moment(), "day")
                ? t("completed")
                : t("ongoing");
            })(),
            [t("start_date")]: data?.prevetive_records?.at(-1)?.date_from
              ? moment(data.prevetive_records.at(-1).date_from).format(
                  "DD-MM-YYYY",
                )
              : "-",

            [t("end_date")]: data?.prevetive_records?.at(-1)?.date_to
              ? moment(data.prevetive_records.at(-1).date_to).format(
                  "DD-MM-YYYY",
                )
              : "-",
          }));
    console.log("final list", list);
    let list2 = [];
    list2 =
      this.state.report_type === "new arophi"
        ? this.state.report4_List1 &&
          this.state.report4_List1 &&
          this.state.report4_List1.map((data, index) => {
            const मालाविषयक = parseInt(data["मालाविषयक"]) || 0;
            const शरीराविषयक = parseInt(data["शरीराविषयक"]) || 0;
            const अवैध_वाळू_विषयक = parseInt(data["अवैध वाळू विषयक"]) || 0;
            const अवैध_दारु_विषयक = parseInt(data["अवैध दारु विषयक"]) || 0;
            const जुगारविषयक = parseInt(data["जुगारविषयक"]) || 0;
            const भाग_६ = parseInt(data["भाग - ६"]) || 0;
            const इतर = parseInt(data["भाग - ६"]) || 0;

            const total =
              मालाविषयक +
              शरीराविषयक +
              अवैध_वाळू_विषयक +
              अवैध_दारु_विषयक +
              जुगारविषयक +
              भाग_६ +
              इतर;

            return {
              [t("sr.no")]: index + 1,
              [t("crime_police_station")]: data.districtName,
              [t("body_offender")]: शरीराविषयक,
              [t("property_offender")]: मालाविषयक,
              [t("illegal_sand_transportation")]: अवैध_वाळू_विषयक,
              [t("illegal_liquor_related")]: अवैध_दारु_विषयक,
              [t("gambling_related")]: जुगारविषयक,
              [t("section_6")]: भाग_६,
              [t("other_crimes")]: इतर,
              [t("total")]: total,
            };
          })
        : this.state.report_type === "history_sheeter"
          ? this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("history_sheeter_statistics")]: data.Count_district,
              };
            })
          : this.state.report4_List1 &&
            this.state.report4_List1.map((data, index) => {
              return {
                [t("sr.no")]: index + 1,
                [t("police_station")]: data.districtName,
                [t("2_plus_statistics")]: data.crimeCount,
              };
            });
    console.log("showList", showList);
    var arrData =
      showList === "सांख्यिकी" || this.state.report_type == "new arophi"
        ? list2
        : list;
    console.log("arrData", arrData);

    if (!arrData || !arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    console.log("stateName", stateName);
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  getDistrictName = (id) => {
    const { basicDistricts } = this.props;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  download_csv = () => {
    const { t } = this.context;
    const {
      headers,
      rows: ws_data,
      reportTitle: ReportTitle,
      file_name,
    } = this.getGunaExportTableData();

    if (!ws_data.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      // alignment: { vertical: "top", wrapText: true },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    /* ===================== WORKBOOK ===================== */

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const totalCols = 16;

    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("city name", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;
    const dateRange = `${t("from")} ${moment(
      this.state.report_4_startDate,
    ).format("DD-MM-YYYY")} - ${t("to")} ${moment(
      this.state.report_4_endDate,
    ).format("DD-MM-YYYY")}`;

    /* ===================== TITLES ===================== */

    XLSX.utils.sheet_add_aoa(ws, [[cityName]], {
      origin: "A1",
    });
    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[dateRange]], { origin: "A3" });
    ws["A3"].s = subTitleStyle;
    merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });

    /* ===================== HEADERS ===================== */

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });
    headers.forEach((_, c) => {
      ws[XLSX.utils.encode_cell({ r: 3, c })].s = headerStyle;
    });

    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A5" });

    ws_data.forEach((row, r) =>
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 4, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      }),
    );

    const footerRowIndex = ws_data.length + 6;

    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });
    /* ===================== WIDTH / HEIGHT ===================== */

    ws["!cols"] = [
      { wch: 6 },
      { wch: 18 },
      { wch: 18 },
      { wch: 28 },
      { wch: 12 },
      { wch: 8 },
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 14 },
      { wch: 16 },
      { wch: 36 },
      { wch: 22 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
    ];

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 28 }, { hpt: 42 }];

    for (let i = 4; i < ws_data.length + 4; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: 4 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });
  };

  filterkey = (e) => {
    this.setState({ key: e.key });
  };

  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;

    if (value === "yes") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else {
      filtered = report4_List_backup;
    }

    this.setState({
      report4_List: filtered,
      total: filtered.length,
      arophiList: filtered,
      arophiCount: filtered,
      arophiListCount: filtered,
      newArophiData: filtered,
    });
  };
  render() {
    const { report_4_startDate, report_4_endDate, key, direction, order_by } =
      this.state;
    const { t } = this.context;
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading, pc_crimetitles } = professionals;
    console.log("this district_name", this.state.district_name);
    console.log("this props plus", this.props.user);
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="name">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {t("sort_by_name")}

            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "name" && direction === "ASC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "ASC")} // Toggle to ASC on click
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "name" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "DESC")} // Toggle to DESC on click
            />
          </div>
        </Menu.Item>

        <>
          <Menu.Item key="districtName">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {this.props.users && this.props.users.role === "2"
                ? t("sort_by_police_station")
                : t("sort_by_district_name")}

              <ArrowUpOutlined
                title="ASC"
                style={{
                  color:
                    key === "districtName" && direction === "ASC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("districtName", "ASC")} // Toggle to ASC
              />
              <ArrowDownOutlined
                title="DESC"
                style={{
                  color:
                    key === "districtName" && direction === "DESC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("districtName", "DESC")} // Toggle to DESC
              />
            </div>
          </Menu.Item>

          <Menu.Item key="totalCrimeCount">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {t("sort_by_total_crimes")}

              <ArrowUpOutlined
                title="ASC"
                style={{
                  color:
                    key === "totalCrimeCount" && direction === "ASC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
              />
              <ArrowDownOutlined
                title="DESC"
                style={{
                  color:
                    key === "totalCrimeCount" && direction === "DESC"
                      ? "#1890ff"
                      : "#bfbfbf",
                }}
                onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
              />
            </div>
          </Menu.Item>
        </>
      </Menu>
    );
    console.log("this.myTableRef.current", this.myTableRef.current);
    console.log("this.state.filter", this.state.filter);
    console.log("users", this.props.user);
    const isGraphTab = this.state.activeMainTab === "graph";
    const reportStartDate = isGraphTab
      ? this.state.graphAppliedStartDate
      : report_4_startDate;
    const reportEndDate = isGraphTab
      ? this.state.graphAppliedEndDate
      : report_4_endDate;
    const reportShowList = isGraphTab ? "graph" : this.state.showList;
    return (
      <div className="col-md-6 col-md-offset-3" style={styles.pageContainer}>
        <div style={styles.filterSection}>
          <div style={styles.filterRow}>
            <Form.Item
              name="heading"
              label={t("report")}
              style={styles.formItem}
            >
              <Select
                style={styles.selectInput}
                placeholder="Please select a report"
                value={this.state.report_type}
                onChange={this.selectReportType}
                optionLabelProp="label"
                dropdownMatchSelectWidth={false}
              >
                <Option
                  key={1}
                  value="more_than_two_plus_list"
                  label={t("accused_combined_list_2_plus")}
                >
                  {t("accused_combined_list_2_plus")}
                </Option>
                <Option
                  key={2}
                  value="arophi count"
                  label={t("two_plus_accused")}
                >
                  {t("two_plus_accused")}
                </Option>
                <Option
                  key={4}
                  value="arophi_new_list"
                  label={t("two_plus_accused_list")}
                >
                  {t("two_plus_accused_list")}
                </Option>

                {/* <Option key={5} value="history_sheeter" label={t("history")}>
                  {t("history")}
                </Option> */}
              </Select>
            </Form.Item>

            {this.state.report_type &&
              this.state.report_type != "history_sheeter" && (
                <Form.Item
                  name="heading"
                  label={t("type")}
                  style={styles.formItem}
                >
                  <Select
                    style={styles.selectInput}
                    placeholder={t("please_select_a_report")}
                    value={this.state.filter}
                    onChange={this.selectfilter}
                  >
                    <Option key={2} value="by_distinct">
                      {t("info_within_police_station_limits")}
                    </Option>
                    {/* hide for confusion  */}
                    <Option key={4} value="by_id">
                      {t("data_entered_by_police_station")}
                    </Option>
                  </Select>
                </Form.Item>
              )}
          </div>
        </div>
        <PageHeader
          className="site-page-header"
          ghost={false}
          onBack={false}
          title={
            this.state.report_type == "new arophi"
              ? t("accused_new_cases_statistics")
              : this.state.report_type == "arophi count"
                ? t("two_plus_accused")
                : this.state.report_type == "arophi_new_list"
                  ? t("two_plus_accused_list")
                  : this.state.report_type == "more_than_two_plus_list"
                    ? t("accused_combined_list_2_plus")
                    : this.state.report_type == "history_sheeter"
                      ? t("history")
                      : t("two_plus_accused")
          }
        >
          <Descriptions size="small" column={1}>
            <Descriptions.Item>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                {this.state.report_type != "history_sheeter" && (
                  <>
                    {/* Date Pickers */}
                    <DatePicker
                      style={{ flex: 1, minWidth: "150px" }}
                      value={
                        report_4_startDate ? moment(report_4_startDate) : null
                      }
                      onChange={this.onStartDateChange}
                      placeholder="DD/MM/YYYY"
                      allowClear
                      format={"DD/MM/YYYY"}
                      inputReadOnly
                    />
                    <DatePicker
                      style={{ flex: 1, minWidth: "150px" }}
                      value={report_4_endDate ? moment(report_4_endDate) : null}
                      onChange={this.onEndDateChange}
                      placeholder="DD/MM/YYYY"
                      allowClear
                      disabledDate={this.disabledEndDate}
                      format={"DD/MM/YYYY"}
                      inputReadOnly
                    />
                  </>
                )}

                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  loading={this.state.report4_API_loader}
                  onClick={this.handleFind}
                  disabled={this.isFindDisabled()}
                >
                  {t("find")}
                </Button>

                {this.state.activeMainTab === "list" && (
                  <>
                    <Select
                      placeholder={t("please_select_an_option")}
                      value={this.state.download || "excel"}
                      onChange={(value) => this.setState({ download: value })}
                      style={{ minWidth: "180px" }}
                    >
                      <Option key="arophi_excel">{t("accused_excel")}</Option>
                      {(this.state.showList === "यादी" ||
                        this.state.report_type === "arophi_new_list") && (
                        <Option key="guna_excel">
                          {t("crime_statistics")}
                        </Option>
                      )}
                     {/* <Option key="pdf">PDF</Option>
                      {(this.state.showList === "यादी" ||
                        this.state.report_type === "arophi_new_list") && (
                        <Option key="guna_pdf">
                          {t("crime_statistics")} PDF
                        </Option>
                      )}
                        */}
                    </Select>

                    <Button
                      icon={<DownloadOutlined />}
                      onClick={() => this.downloadReport()}
                      loading={this.state.downloadLoding}
                      disabled={
                        this.state.download === "guna_excel" ||
                        this.state.download === "guna_pdf"
                          ? !this.state.report4_List?.length
                          : !this.state.report4_List?.length ||
                            !this.state.report4_List1?.length
                      }
                    >
                      {t("download")}
                    </Button>

                    {(this.state.showList === "यादी" ||
                      this.state.report_type === "arophi_new_list") && (
                      <Button
                        icon={<FilterOutlined />}
                        onClick={() =>
                          this.setState({
                            showFilterSection: !this.state.showFilterSection,
                          })
                        }
                        disabled={
                          !this.state.report4_List.length ||
                          !this.state.report4_List1.length
                        }
                      >
                        {t("filter")}
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Descriptions.Item>
          </Descriptions>

          {(!this.state.report_type || !this.state.filter) && (
            <Text type="danger">{t("please_select_report_and_type")}</Text>
          )}
          {this.state.activeMainTab === "list" &&
            this.state.showList === "यादी" &&
            (this.state.report4_List.length > 0 ||
              this.state.arophiList.length > 0 ||
              this.state.arophiCount.length > 0 ||
              this.state.arophiListCount.length > 0 ||
              this.state.newArophiData.length > 0) && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <label style={{ fontSize: "15px", fontWeight: "500" }}>
                  फोटो:
                </label>

                <Radio.Group
                  onChange={this.handleAdvancedFilterPhotoChange}
                  value={this.state.advancedFilterPhoto}
                >
                  <Radio value="all">सर्व</Radio>
                  <Radio value="yes">होय</Radio>
                  <Radio value="no">नाही</Radio>
                </Radio.Group>
              </div>
            )}
        </PageHeader>

        {this.state.activeMainTab === "list" &&
          this.state.showFilterSection == true && (
            <div
              style={{
                marginTop: "16px",
                padding: "16px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginBottom: "25px",
              }}
            >
              {/* Title + Sorter Row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  flexWrap: "wrap", // responsive wrap
                }}
              >
                {/* Title Select */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#262626",
                      minWidth: "100px",
                      marginRight: "8px",
                    }}
                  >
                    शीर्षक:
                  </span>
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ flex: 1 }}
                    placeholder={t("please_select_a_title")}
                    onChange={(val) => this.setState({ crimeTitle: val })}
                    value={this.state.crimeTitle}
                  >
                    {pc_crimetitles?.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.crime_title}
                      </Option>
                    ))}
                  </Select>
                </div>

                {/* Sort By Dropdown */}
                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  arrow={{ pointAtCenter: true }}
                  overlayStyle={{ width: "200px" }}
                >
                  <Button
                    type="primary"
                    style={{
                      minWidth: "140px",
                      backgroundColor: "#1890ff",
                      borderColor: "#1890ff",
                    }}
                    className="modern-button"
                  >
                    {t("sorter_by")} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>

              {/* Button group at bottom right */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                <Button
                  disabled={
                    !(
                      this.state.crimeTitle.length > 0 ||
                      (this.state.order_by && this.state.direction)
                    )
                  }
                  loading={this.state.report4_API_loader}
                  onClick={this.getData}
                  type="primary"
                  icon={<SearchOutlined />}
                  className="modern-button modern-button-success"
                >
                  {t("find")}
                </Button>

                {this.state.is_sort && (
                  <Button
                    onClick={() => this.clearFilter()}
                    icon={<ClearOutlined />}
                    className="modern-button modern-button-danger"
                  >
                    {t("clear")}
                  </Button>
                )}
              </div>
            </div>
          )}

        {this.state.isMoreThanOneYear && (
          <Text type="danger">
            कृपया 5 वर्ष किंवा त्या पेक्षा कमी कालावधी निवडा.
          </Text>
        )}

        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={professionals}
          ></ViewFormModel>
        </Modal>

        <React.Suspense fallback={<div>Loading...</div>}>
          {this.state.report_type == "new arophi" ||
          this.state.report_type == "arophi count" ||
          this.state.report_type == "arophi_new_list" ||
          this.state.report_type == "more_than_two_plus_list" ||
          this.state.report_type == "history_sheeter" ? (
            <AropiReport2Plus
              report_type={this.state.report_type}
              startDate={reportStartDate}
              endDate={reportEndDate}
              onViewAccusedForm={this.onViewAccusedForm}
              cityId={user.cityId}
              newArophiData={this.state.newArophiData}
              arophiCount={this.state.arophiCount}
              arophiList={this.state.arophiList}
              arophiListCount={this.state.arophiListCount}
              historyList={this.state.historyList}
              historyCount={this.state.historyCount}
              showList={reportShowList}
              getShowList={this.getShowList}
              user={user}
              total={this.state.total}
              loading={this.state.report4_API_loader}
              professionals={this.props.professionals}
              preventiveAction={this.state.preventiveAction}
              filter={this.state.filter}
              graphOnly={isGraphTab}
              graphRefreshKey={this.state.graphRefreshKey}
              showGraphToggle={this.state.report_type !== "new arophi"}
              isGraphView={isGraphTab}
              onToggleGraph={this.toggleGraphView}
              onTableSortChange={this.handleTableSortChange}
              onDistrictFilterChange={this.handleDistrictFilterChange}
              onPreventiveFilterChange={this.handlePreventiveFilterChange}
              onVisibleRowsChange={this.handleVisibleRowsChange}
            />
          ) : (
            <TableReport2Plus
              key={this.state.report4_List}
              data={this.state.report4_List}
              allTotal={this.state.report4_List.length}
              total={this.state.report4_List.length}
              onViewAccusedForm={this.onViewAccusedForm}
              preventiveAction={this.state.preventiveAction}
            ></TableReport2Plus>
          )}
        </React.Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedPlus2ReportPolice = connect(mapStateToProps)(Plus2ReportPolice);
export { connectedPlus2ReportPolice as Plus2ReportPolice };
